import { useEffect, useState } from "react";

export const usePersistedTableSettings = (key) => {
  const [settings, setSettings] = useState({
    columnVisibility: {},
    columnFilters: [],
    sorting: [],
    columnOrder: [],
  });

  useEffect(() => {
    if (!key) return;
    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        setSettings({
          columnVisibility: parsed.columnVisibility || {},
          columnFilters: parsed.columnFilters || [],
          sorting: parsed.sorting || [],
          columnOrder: parsed.columnOrder || [],
        });
      }
    } catch (e) {
      console.warn("Failed to load table settings", e);
    }
  }, [key]);

  useEffect(() => {
    if (key) {
      localStorage.setItem(key, JSON.stringify(settings));
    }
  }, [key, settings]);

  const updateState = (key, valueOrFn) => {
    setSettings((prev) => ({
      ...prev,
      [key]: typeof valueOrFn === 'function' ? valueOrFn(prev[key]) : valueOrFn,
    }));
  };

  return {
    settings,
    setColumnVisibility: (val) => updateState('columnVisibility', val),
    setColumnFilters: (val) => updateState('columnFilters', val),
    setSorting: (val) => updateState('sorting', val),
    setColumnOrder: (val) => updateState('columnOrder', val),
    resetSettings: () =>
      setSettings({
        columnVisibility: {},
        columnFilters: [],
        sorting: [],
        columnOrder: [],
      }),
  };
};